export default {
  sm: `
  225만 그루의
  나무를 심다.
  `,
  lg: `
  225만
  그루의
  나무를 심다.
  `
};
